/* @flow */
import SettingsStore from 'stores/SettingsStore';

const settings = {
  weekday: { early: 7, late: 21 },
  weekend: { early: 9, late: 21 },
};

SettingsStore.addListener(() => {
  Object.assign(settings, SettingsStore.getMessagesTiming());
});

export default {
  isWeekend(date: Date = new Date()) {
    return date.getDay() === 0 || date.getDay() === 6;
  },

  isWeekday(date: Date = new Date()) {
    return !this.isWeekend(date);
  },

  isLate(date: Date = new Date()) {
    const hour = date.getHours();
    return (
      (this.isWeekend() && hour >= settings.weekend.late) ||
      (this.isWeekday() && hour >= settings.weekday.late)
    );
  },

  isEarly(date: Date = new Date()) {
    const hour = date.getHours();
    return (
      (this.isWeekend() && hour < settings.weekend.early) ||
      (this.isWeekday() && hour < settings.weekday.early)
    );
  },
};



// WEBPACK FOOTER //
// ./src/lib/Timing.js